import { render, staticRenderFns } from "./TerminalLogs.vue?vue&type=template&id=4861a656&scoped=true&"
import script from "./TerminalLogs.vue?vue&type=script&lang=js&"
export * from "./TerminalLogs.vue?vue&type=script&lang=js&"
import style0 from "./TerminalLogs.vue?vue&type=style&index=0&id=4861a656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4861a656",
  null
  
)

export default component.exports